import React from "react";
import PropTypes from "prop-types";
import "./layout.css";

// const pagination_item = {
//     display: "inline-block",
//     width: "20px",
//     textAlign: "center",
//     cursor: "pointer",
//     fontFamily:"Roboto",
//     fontSize:"12px"
// }

// const pagination_current_page = {
//     display: "inline-block",
//     width: "20px",
//     textAlign: "center",
//     fontWeight: "bold",
//     fontFamily:"Roboto",
//     fontSize:"14px",
// }

const Pagination = (props) => {
  let prev_pages = [];
  let next_pages = [];

  var i;
  for (i = props.page - props.pageSpan; i < props.page; i++) {
    let page = i;
    if (i > 0)
      prev_pages.push(
        <span
          key={`prev-${i}`}
          onClick={() => props.handleOnChange(page, props.name)}
          className="itemPage"
        >
          {i}
        </span>
      );
  }
  for (i = props.page + 1; i <= props.page + props.pageSpan; i++) {
    let page = i;
    if (i <= props.totalPages)
      next_pages.push(
        <span
          key={`next-${i}`}
          onClick={() => props.handleOnChange(page, props.name)}
          className="itemPage"
        >
          {i}
        </span>
      );
  }

  return props.totalPages === 0 ? (
    <div style={{ textAlign: "center", verticalAlign: "middle", fontSize: "12px" }}>
      No hay registros para mostrar
    </div>
  ) : (
    <div className="containerPaginacion">
      <div className="containerInner">
        {
          /**primer pagina */ props.page > props.pageSpan ? (
            <span className="itemPage" onClick={() => props.handleOnChange(0, props.name)}>
              {" << "}
            </span>
          ) : undefined
        }

        {
          /**pagina anterior */ props.page > 1 ? (
            <span
              className="itemPage"
              onClick={() => props.handleOnChange(props.page - 1, props.name)}
            >
              {" < "}
            </span>
          ) : undefined
        }

        {[
          ...prev_pages,
          <span key="current-page" className="itemPage currentPage">
            {props.page}
          </span>,
          ...next_pages,
        ]}

        {
          /**pagina siguiente */ props.page < props.totalPages ? (
            <span
              className="itemPage"
              onClick={() => props.handleOnChange(props.page + 1, props.name)}
            >
              {" > "}
            </span>
          ) : undefined
        }

        {props.page < props.totalPages - props.pageSpan ? (
          <span
            className="itemPage"
            onClick={() => props.handleOnChange(props.totalPages, props.name)}
          >
            {" >> "}
          </span>
        ) : undefined}
      </div>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  pageSpan: PropTypes.number,
};

Pagination.defaultProps = {
  pageSpan: 2,
};

export default Pagination;
